import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '1080px',
    padding: '0',
    [theme.breakpoints.down('lg')]: {
      width: '940px',
    },
    [theme.breakpoints.down('md')]: {
      width: '700px',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      padding: '0 20px',
    },
    '& *:focus': {
      outline: 'none',
    },
    '& .menuPreferences': {
      display: 'flex',
      marginBottom: '67px',

      textTransform: 'uppercase',
      width: '100%',
      [theme.breakpoints.down('md')]: {
        marginBottom: '52px',
        width: '95%',
      },
      [theme.breakpoints.down('xs')]: {
        marginBottom: '42px',
        padding: '0 0 0 1px',
      },
      '& .slick-list': {
        overflow: 'visible',
      },

      '& .slick-slide': {
        padding: '0',
      },
      '& .slick-current': {
        borderBottom: `4px solid ${theme.palette.blue2}`,
        '&  span': {
          color: theme.palette.blue2,
          fontWeight: 'bold',
        },
      },

      '&__item': {
        color: theme.palette.grey2,
        letterSpacing: theme.typography.pxToRem(2),
        padding: `${theme.typography.pxToRem(10)} 0`,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        [theme.breakpoints.down('md')]: {
          padding: `${theme.typography.pxToRem(10)} ${theme.typography.pxToRem(0)}`,
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: theme.typography.pxToRem(12),
          padding: `${theme.typography.pxToRem(10)} 
           ${theme.typography.pxToRem(14)}
           ${theme.typography.pxToRem(8)}`,
        },
        [theme.breakpoints.down('xs')]: {
          padding: `${theme.typography.pxToRem(10)} 
           ${theme.typography.pxToRem(12)}
           ${theme.typography.pxToRem(8)}`,
        },
      },
      '& .slick-active': {
        fontSize: theme.typography.pxToRem(14),
        '& li': {
          color: theme.palette.blue2,
          fontFamily: 'ProximaBold',
        },
      },
    },
    '& .introPreferences': {
      marginBottom: '20px',
      [theme.breakpoints.down('md')]: {
        marginBottom: '15px',
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: '20px',
      },
      '&__title': {
        fontFamily: 'ProximaSemibold',
        color: theme.palette.blue1,
        fontSize: theme.typography.pxToRem(32),
        textAlign: 'left',
        lineHeight: '48px',
        [theme.breakpoints.down('lg')]: {
          fontSize: '30px',
          lineHeight: '45px',
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: '24px',
          lineHeight: '36px',
        },
      },
      '&__subTitle': {
        fontSize: theme.typography.pxToRem(18),
        lineHeight: theme.typography.pxToRem(27),
        textAlign: 'left',
        fontWeight: 'normal',
        marginTop: '10px',
        [theme.breakpoints.down('lg')]: {
          fontSize: '16px',
          lineHeight: '24px',
        },
      },
      '& .slick-slide': {
        padding: '0',
        width: '100%',
      },
    },
    '& .formPreferences': {
      minHeight: '675px',
      padding: '30px 40px',
      paddingBottom: '0',
      '& .MuiFormControl-root': {
        minHeight: theme.typography.pxToRem(80),
      },
      '& .Mui-disabled': {
        color: theme.palette.grey6,
        '&.MuiSelect-root.MuiSelect-select.MuiSelect-selectMenu.MuiInputBase-input.MuiInput-input.MuiInputBase-inputSelect, &.MuiInputBase-input.MuiInput-input':
          {
            color: `${theme.palette.grayBlue} !important`,
          },
        '& input': {
          border: '0',
        },
      },
      '& .MuiInput-input': {
        background: theme.palette.white,
        border: '0',
      },
      '& .MuiInput-root.Mui-error': {
        border: `1px solid ${theme.palette.error.main}`,
      },
      [theme.breakpoints.down('lg')]: {
        padding: '30px',
        paddingBottom: '0',
      },
      [theme.breakpoints.down('md')]: {
        padding: '30px 20px',
        paddingBottom: '0',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '20px',
        paddingBottom: '0',
      },
    },
    '& .guestInfoForms': {
      width: '65%',
      '& .MuiGrid-item': {
        textAlign: 'left',
        padding: '15px',
        paddingBottom: '19px',
        [theme.breakpoints.down('md')]: {
          padding: '10px',
          paddingBottom: '24px',
        },
        [theme.breakpoints.down('sm')]: {
          maxWidth: '100%',
          flexBasis: '100%',
        },
        '& .MuiInputBase-root': {
          width: '100%',
          background: theme.palette.white,
          border: `1px solid ${theme.palette.grey7}`,
          borderRadius: '3px',
        },
      },
      '& .MuiInputAdornment-root.CasIcon-root': {
        position: 'relative',
        left: '250px',
        top: '10px',
        '& .MuiSvgIcon-root': {
          fill: theme.palette.blue1,
        },
      },
      '& [id$=cas-helper-text]': {
        position: 'relative',
      },
      '& [name$=email]': {
        textTransform: 'lowercase',
      },
      [theme.breakpoints.down('md')]: {
        width: '75%',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
      [theme.breakpoints.down('xs')]: {
        padding: '0',
      },
      '& .MuiBox-root': {
        padding: '44px 0',
        paddingBottom: '10px',
        [theme.breakpoints.down('lg')]: {
          padding: '34px 0',
          paddingBottom: '10px',
        },
      },
    },
    '& .guestTabs': {
      minHeight: 'auto',
      '& button': {
        color: theme.palette.grey2,
        width: '25%',
        minHeight: '27px',
        height: '27px',
        [theme.breakpoints.down('md')]: {
          paddingLeft: '0',
        },
        [theme.breakpoints.down('sm')]: {
          padding: '0',
          minHeight: theme.typography.pxToRem(60),
          minWidth: 'auto',
          maxWidth: '65px',
          marginRight: '14px',
        },
        '&.Mui-selected': {
          color: theme.palette.blue2,
          fontFamily: 'ProximaSemiBold',
          '& svg.adult-icon g': {
            fill: theme.palette.blue2,
          },
        },
        '& .tabText': {
          display: 'inline-block',
          '&:focus': {
            outline: 'none',
          },
        },
        '& .checkMark': {
          display: 'none',
          height: '11px',
          marginLeft: '4px',
          marginTop: '-3px',
          position: 'relative',
          verticalAlign: 'middle',
          width: '16px',
        },
        '&.noErrors': {
          '& .checkMark': {
            display: 'inline-block',
          },
          '& :focus': {
            outline: '-webkit-focus-ring-color auto 1px',
          },
        },
        '& svg': {
          marginLeft: '-9px',
          marginBottom: '0',
        },
        '&.Mui-disabled': {
          color: theme.palette.grey2,
          opacity: '1',
          '& svg': {
            opacity: '0.5',
          },
        },
      },
      '& .MuiTab-wrapper': {
        alignItems: 'baseline',
        display: 'inline-block',
        fontSize: theme.typography.pxToRem(18),
        lineHeight: theme.typography.pxToRem(27),
        paddingLeft: theme.typography.pxToRem(10),
        textAlign: 'left',
        '& span': {
          textTransform: 'capitalize',
        },
        [theme.breakpoints.down('md')]: {
          fontSize: theme.typography.pxToRem(16),
          lineHeight: theme.typography.pxToRem(24),
          '& svg': {
            display: 'none',
          },
          paddingLeft: '0',
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: theme.typography.pxToRem(12),
          lineHeight: theme.typography.pxToRem(18),
          paddingLeft: '0',
        },
      },
    },
    '& .formTitle': {
      borderBottom: `1px solid ${theme.palette.grey6}`,
      color: theme.palette.blue1,
      fontSize: theme.typography.pxToRem(24),
      lineHeight: theme.typography.pxToRem(36),
      fontFamily: 'ProximaSemiBold',
      marginBottom: theme.typography.pxToRem(30),
      paddingTop: theme.typography.pxToRem(4),
      paddingRight: theme.typography.pxToRem(0),
      paddingBottom: theme.typography.pxToRem(20),
      textAlign: 'left',
      textTransform: 'capitalize',
      [theme.breakpoints.down('md')]: {
        marginBottom: theme.typography.pxToRem(20),
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(18),
        lineHeight: theme.typography.pxToRem(27),
      },
    },
    '& .actions': {
      background: theme.palette.grey4,
      margin: '0 -40px',
      maxWidth: '1440px',
      padding: '20px 32px 24px 0',
      position: 'sticky',
      textAlign: 'right',
      top: '100%',
      width: 'calc(100% + 80px)',
      [theme.breakpoints.down('md')]: {
        padding: '20px 24px 24px 0',
        margin: '0 -24px',
        width: 'calc(100% + 48px)',
      },
      [theme.breakpoints.down('sm')]: {
        margin: '0 -24px',
      },
      [theme.breakpoints.down('xs')]: {
        margin: '0 -16px 20px',
        padding: '20px',
        width: 'auto',
      },
      '& .MuiButtonBase-root': {
        borderRadius: '3px',
        background: theme.palette.blue2,
        boxShadow: 'none',
        color: 'white',
        fontFamily: 'ProximaBold',
        fontSize: theme.typography.pxToRem(13),
        letterSpacing: theme.typography.pxToRem('2'),
        padding: '10px 38px',
        width: 'auto',
        [theme.breakpoints.down('md')]: {
          padding: '10px 36px',
        },
        [theme.breakpoints.down('xs')]: {
          width: '100%',
        },
        '&.Mui-disabled': {
          background: theme.palette.grey2,
        },
      },
    },
    '& .nextSteps': {
      color: theme.palette.blue2,
      margin: '24px auto 0',
      maxWidth: '1092px',
      padding: '16px 0',
      textAlign: 'right',
      '& p, & svg': {
        display: 'inline-block',
        verticalAlign: 'middle',
      },
      '& svg': {
        margin: '2px 0 0 12px',
      },
    },
    '& .slick-list': {
      overflow: 'hidden',
      width: '100%',
    },
    '& .slick-track': {
      display: 'flex',
      width: '100%',
    },
    '& .slick-slide': {
      border: '0',
      display: 'inline-block',

      padding: '2px 45px',
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        flexGrow: '1',
      },
      '&:hover': {
        cursor: 'pointer',
      },
    },
    '& .slick-slider': {
      position: 'relative',
    },
    '& .slick-active': {
      zIndex: '10',
    },
    '& .MuiGrid-container': {
      '&.MuiGrid-spacing-xs-3': {
        width: 'calc(100% + 22px)',
        [theme.breakpoints.down('lg')]: {
          width: 'calc(100% + 36px)',
        },
        [theme.breakpoints.down('md')]: {
          width: 'calc(100% + 185px)',
          margin: '-10px',
        },
        [theme.breakpoints.down('sm')]: {
          width: 'calc(100% + 20px)',
        },
      },
    },
  },
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0,0,0,0.75)',
    },
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    maxWidth: '640px',
    padding: '80px 111px',
    position: 'relative',
    '& :focus': {
      outlineWith: '0px',
    },
    [theme.breakpoints.only('lg')]: {
      padding: '80px',
      maxWidth: '584px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '60px',
      maxWidth: '464px',
    },
    [theme.breakpoints.only('xs')]: {
      maxWidth: '90%',
      padding: '34px 32px 32px',
    },
  },
  closeButton: {
    color: theme.palette.blue2,
    position: 'absolute',
    right: '20px',
    top: '20px',
    [theme.breakpoints.only('xs')]: {
      right: '10px',
      top: '10px',
    },
  },
  closeIcon: {
    fontSize: theme.typography.pxToRem(32),
    [theme.breakpoints.only('xs')]: {
      fontSize: theme.typography.pxToRem(20),
    },
  },
  modalTitle: {
    color: theme.palette.blue1,
    letterSpacing: '2px',
    paddingBottom: '22px',
    textTransform: 'uppercase',
    [theme.breakpoints.only('xs')]: {
      fontSize: theme.typography.pxToRem(20),
    },
  },
  modalContent: {
    color: theme.palette.grey1,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(27),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
    },
    [theme.breakpoints.only('xs')]: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(24),
    },
    '&:last-child': {
      paddingTop: '14px',
    },
  },
  hideIcons: {
    '& svg': {
      display: 'none',
    },
    '& .MuiInputAdornment-positionStart': {
      width: '8px',
    },
  },
  textFieldField: {
    paddingTop: '15px !important',
    paddingBottom: '14px !important',
  },
  containerFields: {
    '& .MuiInputAdornment-positionStart': {
      paddingLeft: '10px',
      background: theme.palette.white,
    },
  },
  datePickerField: {
    paddingTop: '6px !important',
    paddingBottom: '6px !important',
    border: '0 !important',
  },
  phoneInput: {
    width: '100%',
    paddingLeft: '50px',
    fontFamily: theme.typography.proxima.regular,
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.grey1,
    border: `1px solid ${theme.palette.grey7}`,
  },
  phoneInputWrapper: {
    '& .special-label': {
      display: 'block',
      top: '-20px',
      left: 0,
      color: theme.palette.grey9,
      fontFamily: theme.typography.proxima.regular,
      fontSize: theme.typography.pxToRem(14),
      transform: 'translate(0, 4.5px) scale(0.75)',
      transformOrigin: 'top left',
    },

    '& .invalid-number-message': {
      bottom: '-19px',
      fontSize: theme.typography.pxToRem(11),
      top: 'unset',
      left: 0,
      background: theme.palette.white,
    },
  },
  dropdownClass: {
    top: 40,
    width: '274px !important',

    [theme.breakpoints.down('md')]: {
      minWidth: 'auto',
      width: '320px !important',
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 'calc(100vw - 80px)',
      width: 'auto',
    },
    [theme.breakpoints.up('xl')]: {
      width: '306px !important',
    },
  },
}));

export default useStyles;
